/* eslint-disable consistent-return, @typescript-eslint/no-misused-promises, no-unneeded-ternary */
import { useCallback, useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';
import { confirmWrapper } from 'src/components/Dialog';

function useConfirmExit(confirmExit: () => Promise<boolean>, when = true) {
  const { navigator } = useContext(NavigationContext) || { navigator: null };

  useEffect(() => {
    if (!when) {
      return;
    }
    if (navigator) {
      const { push } = navigator;
      navigator.push = async (...args: Parameters<typeof push>) => {
        const result = await confirmExit();
        if (result !== false) {
          push(...args);
        }
      };

      return () => {
        navigator.push = push;
      };
    }
  }, [navigator, confirmExit, when]);
}

export default function usePrompt(message: string, when = true) {
  useEffect(() => {
    if (when) {
      window.onbeforeunload = function () {
        return message;
      };
    }

    return () => {
      window.onbeforeunload = null;
    };
  }, [message, when]);

  const confirmExit = useCallback(async () => {
    const isAccepted = await confirmWrapper(
      message,
      {
        variant: 'danger',
        primaryBtnLabel: 'Continue',
        secondaryBtnLabel: 'Stay here',
        containerClasses: 'max-w-[450px]',
      },
    );
    return isAccepted ? true : false;
  }, [message]);
  useConfirmExit(confirmExit, when);
}
